import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { AdminTaskListService } from '../../services/admin-task-list.service';
import { Subscription } from 'rxjs';
import { TaskType } from 'src/app/services/tasklist.service';
import { ConfigS3UploadService, s3Link } from '../../services/config-s3-upload.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GeaMesCognitoAuthService } from '@gea-mes/cognito';
import { first } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { AdminTaskFileAssociateDialog } from '../admin-task-file-associate-dialog/admin-task-file-associate-dialog.component';
import { PdfUploadDialog } from './pdf-upload-dialog/pdf-upload-dialog.component';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';
import { MatTable, MatColumnDef, MatCellDef, MatCell, MatRowDef, MatRow } from '@angular/material/table';

@Component({
    selector: 'app-admin-task-file-dialog',
    templateUrl: './admin-task-file-dialog.component.html',
    styleUrls: ['./admin-task-file-dialog.component.scss'],
    imports: [MatDialogTitle, MatButton, MatIcon, CdkScrollable, MatDialogContent, NgIf, MatTable, MatColumnDef, MatCellDef, MatCell, MatRowDef, MatRow]
})
export class AdminTaskFileDialog implements OnInit {

  task:TaskType;
  site: string;
  environment: string;
  object: string;

  fileListSub$: Subscription;
  fileList: any[];

  adminFlag: boolean;
  adminSub$: Subscription;

  displayedColumns: string[] = [ 'image','actions'];

  constructor(
    public dialogRef: MatDialogRef<AdminTaskFileDialog>,
    @Inject(MAT_DIALOG_DATA) public inData: any,
    public dialog: MatDialog,
    private snakBar: MatSnackBar,
    private geaMesCognito: GeaMesCognitoAuthService,
    private svcAdminTaskList:AdminTaskListService,
    private svcS3Upload: ConfigS3UploadService
  ) { 
    this.task = inData['task'];
    this.site = inData['site'];
    this.environment = inData['environment'];
    this.object = inData['object'];

    // Check to see if this user is an admin
    this.adminSub$ = this.geaMesCognito.isUserInRole("Admin").pipe(first()).subscribe( out => { 
      this.adminFlag = out;
      if (this.adminSub$) this.adminSub$.unsubscribe(); // We've got an answer, can unsubscribe now
    });

  }


  ngOnInit(): void {
    console.log("TASK", this.task);

    this.loadFileList();
  }

  loadFileList(): void {
    if (this.fileListSub$) this.fileListSub$.unsubscribe();

    this.fileListSub$ = this.svcAdminTaskList.taskFileList(this.task.id).subscribe(
      (out) => {
        this.fileList = out.Body;
        console.log("fileList", this.fileList);
      }
    )
  }

  addFile(): void {
    const fileUpload = document.getElementById('fileImageUpload') as HTMLInputElement;
    fileUpload.onchange = () => {
          for (let index = 0; index < fileUpload.files.length; index++) {
                const file = fileUpload.files[index];
                this.startUpload(file);
          }
    };

    fileUpload.click();
  };

  associateFile(): void {
    let nextDisplayOrder:number = this.fileList && this.fileList.length > 0 ? this.fileList[this.fileList.length - 1]['display_order'] + 1 : 1;

    const dialogRef = this.dialog.open(AdminTaskFileAssociateDialog, {
      width: '800px',
      data: {task: this.task,
            files: this.fileList,
            site: this.site,
            environment: this.environment,
            object: this.object,
            nextDisplayOrder: nextDisplayOrder
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.NewFiles) {
        this.loadFileList();
      }
    });
  }

  startUpload(file: File) {
    let displayOrder:number;
    
    if (this.fileList && this.fileList.length > 0) {
      displayOrder = this.fileList[this.fileList.length - 1].display_order + 1;
    } else {
      displayOrder = 1;
    }

    this.svcAdminTaskList.uploadFile(this.site, this.environment, this.object, this.task.id, file.name, displayOrder).subscribe((
      out => {
        this.completeUpload(out.Body,file);

        if (file.name.substring(file.name.length - 4).toLowerCase() == ".pdf") {
          // PDF File was uploaded, show dialog to let user know it will be a few minutes until images show.
          const dialogRef = this.dialog.open(PdfUploadDialog, {
            width: '400px',
            data: {}
          });

          dialogRef.afterClosed().subscribe(result => {
            this.loadFileList();
          });
        }

    }));
  }

  completeUpload(signedURLInfo: s3Link, file: File) {
    this.svcS3Upload.uploadFile(signedURLInfo, file).subscribe(out => {
      this.snakBar.open(`File ${file.name} Uploaded.`, "Complete", { duration: 2000 } );
      this.loadFileList();
    });
  }

  deleteFile(id:number) {
    if (confirm("Are you sure you would like to delete this image?")) {
      this.svcAdminTaskList.deleteFile(id).subscribe((
        out => {
          console.log("File deleted", out);
          this.loadFileList();

      }));
    }
  }

  changeOrder(id:number, currentDisplayOrder:number, change:number) {
    let updates:any = [];

    // Only allow moving up or down one spot
    if (change == 1 || change == -1) {
      this.fileList.forEach(
        (file) => {
          let newDisplayOrder:number = -1;

          if (file.display_order == currentDisplayOrder + change) {
            newDisplayOrder = file.display_order - change;
          } else if (file.display_order == currentDisplayOrder) {
            newDisplayOrder = file.display_order + change;
          } else {
            newDisplayOrder = file.display_order;
          }

          updates.push({"ID": file.id, "NewDisplayOrder": newDisplayOrder});
        }
      );

      this.svcAdminTaskList.updateOrder(updates).subscribe((
        out => {
          console.log("Order changed", out);
          this.loadFileList();
      }));
    }
  }
}
